import React, { Component } from 'react';

import CommonSubHeader from '../../SubHeader';

import './SubHeader.css';
import { inject, observer } from 'mobx-react';
import AirButton from '../../../../common/components/AirButton';
import { DownloadIcon } from '../../../../common/icons';
import AdvancedFilter from "./AdvancedFilter";
import FullTextSearch from "./FullTextSearch";

@inject('translationsStore')
@observer
export default class SubHeader extends Component {

  render() {
    const { translationsStore } = this.props;
    return (
      <CommonSubHeader className="SMDSubHeader">
        <FullTextSearch placeholder={this.props.translationsStore.translate('search.placeholderSearch')} />
          <div className="filtersExport">
            <AdvancedFilter subscriptions={this.props.subscriptions} />
            <AirButton className="export" icon={<DownloadIcon style={{ width: '13px', height: '16px' }} />} label={translationsStore.translate('export')} onClick={this.props.onExportClick} />
          </div>
      </CommonSubHeader>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/App/SubscriptionManagerDashboard/SubHeader/SubHeader.js